// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-07f3dbdb] {\n  position: relative;\n  height: 100%;\n}\n.w-full-picker[data-v-07f3dbdb] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
